/* eslint-disable max-len */
import Conciliation2Bank from './../conciliation2-bank/index.vue';
import Conciliation2RDOperations from './../conciliation2-rd-operations/index.vue';
import commonFunctions from '../../common-functions';

export default {
    /**
     * Nombre del componente
     */
    name: 'Conciliation2Resume',

    extends: commonFunctions,

    components: { Conciliation2Bank, Conciliation2RDOperations },

    data() {

        return {
            product: '',
            currency: '',
            showDetails: false,
            comment: ''
        };
    },

    /**
     * @override
     */
    props: {
        monitorType: {
            type: String,
            required: false,
            default: 'all'
        }
    },
    created() {
        // this.comment = this.getComment;
    },

    mounted() {
        this.product = this.$route.query.product;
        this.currency = this.$route.query.currency;
    },

    methods: {
        /**
         * @override
         */
        showDetailsAction() {
            this.showDetails = !this.showDetails;
        },

        actionGroup(status) {
            if (!status) {
                return false;
            }

            const bankOperationsList = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/bankOperations`];
            const RDOperationsList = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/RDOperations`];

            const payload = {
                status,
                comment: this.comment,
                bankOperations: bankOperationsList.map(transaction => transaction.uuid),
                RDOperations: RDOperationsList.map(operation => operation.uuid),
                product: this.product,
                currency: this.currency
            };

            if (this.groupedSelected) {
                this.$paymentsService
                    .patchConciliation2(this.uuidGroupedSelected, payload)
                    .then(() => {
                        if (status === 'DESVINCULAR') {
                            this.$toast.success(`Desvinculado`, `Datos desvinculados con éxito.`);
                        } else {
                            this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                        }
                        this.clearSelection(`Conciliation2Detail${this.product}-${this.currency}`);
                    })
                    .catch(err => console.error(err));
            } else {
                this.$paymentsService
                    .setConciliation2(payload)
                    .then(() => {
                        this.$toast.success(`Guardado`, `Agrupación guardada con éxito.`);
                        this.clearSelection(`Conciliation2Detail${this.product}-${this.currency}`);
                        this.$root.$emit('fetch_data');
                    })
                    .catch(err => console.error(err));
            }
        },

        cleanAll() {
            this.$store.dispatch('conciliationStore/setSearchBy', false);
            this.$root.$emit('set_filtering_operations');
            this.$root.$emit('set_filtering_transfers');
            this.clearSelection(`Conciliation2Detail${this.product}-${this.currency}`);
        }
    },

    computed: {
        bankOperations() {
            return this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/bankOperations`] || [];
        },

        RDOperations() {
            return this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/RDOperations`] || [];
        },

        bankOperationsAmmount() {
            let total = 0;
            this.bankOperations.forEach(item => {
                total += +item.importe;
            });
            return total;
        },

        RDOperationsAmmount() {
            let total = 0;
            this.RDOperations.forEach(item => {
                total += +item.importe;
            });
            return total;
        },

        diffAmmount() {
            return this.bankOperationsAmmount - this.RDOperationsAmmount;
        },

        groupedSelected() {
            return this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/groupedSelected`];
        },

        uuidGroupedSelected() {
            return this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/uuidGroupedSelected`];
        },

        hasTransferAndOperations() {
            return this.bankOperations.length && this.RDOperations.length;
        },

        getComment() {
            return this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/comment`];
        },
        disableAll() {
            return this.$store.getters['conciliationStore/disableAll'];
        },
        allowAgrupation() {
            return (this.bankOperations.length + this.RDOperations.length > 1);
        }
    }
};
